module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3048926480/src/~/core-js/library/modules/_redefine.js
// module id = L1xW
// module chunks = 6